import {
    fetchIssueInfo,
    fetchIssueRecentLobbying,
    fetchIssueRegistrations,
    fetchSentences,
    fetchIssueUpdates,
    fetchKeywordMentions,
    fetchMentionCluster,
    fetchIssueTweets,
    fetchIssueGovernmentAnnouncements,
    fetchIssueSummary,
    fetchGazette,
    fetchClusters,
    fetchSubjectMatterDetailsSummary,
    fetchIssueMpSocialOverview,
    fetchIssueSenatorSocialOverview,
    fetchIssueProcessedCommunications,
} from '../store/issueSlice';

const issueSharedDispatches = (dispatch: any, entityCode: string, date: string) => {
    dispatch(fetchIssueInfo({ code: entityCode }));
    dispatch(fetchIssueUpdates({ code: entityCode, date: date }));
    dispatch(fetchIssueMpSocialOverview({ code: entityCode, date: date }));
    dispatch(fetchIssueSenatorSocialOverview({ code: entityCode, date: date }));
    dispatch(fetchKeywordMentions({ code: entityCode, date: date }));
};

const issueLobbyingDispatches = (dispatch: any, entityCode: string, date: string) => {
    dispatch(fetchIssueRecentLobbying({ code: entityCode, date: date }));
    dispatch(fetchIssueRegistrations({ code: entityCode, date: date }));
    dispatch(fetchClusters({ code: entityCode, date: date }));
    dispatch(fetchSubjectMatterDetailsSummary({ code: entityCode, date: date }));
    dispatch(fetchIssueProcessedCommunications({ code: entityCode, date: date }));
};

const issueParliamentaryDispatches = (dispatch: any, entityCode: string, date: string) => {
    dispatch(fetchIssueGovernmentAnnouncements({ code: entityCode, date: date }));
    dispatch(fetchIssueTweets({ code: entityCode, date: date }));
    dispatch(fetchSentences({ code: entityCode, date: date }));
    dispatch(fetchMentionCluster({ code: entityCode, date: date }));
    dispatch(fetchGazette({ code: +entityCode, date: date }));
    dispatch(fetchIssueSummary({ code: entityCode, date: date }));
};

export const IssueDispatches = {
    issueSharedDispatches,
    issueLobbyingDispatches,
    issueParliamentaryDispatches,
};
